import { ChevronRight } from "lucide-react";
import { haptics } from "../lib/haptics";
import { GroupOut } from "../lib/schemas";
import { Avatar, BalanceAmount } from "../ui";

interface Props {
  group: GroupOut;
  onClick: () => void;
}

export default function GroupCard({ group, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={() => { haptics.tap(); onClick(); }}
      className="bg-surface border border-hairline rounded-2xl shadow-card p-4 mb-2.5 w-full text-left flex items-center gap-3 active:bg-surface-2 active:scale-[0.99] transition-all"
    >
      <Avatar name={group.title} size="md" />
      <div className="flex flex-col gap-0.5 min-w-0 flex-1">
        <span className="text-fg font-medium truncate">{group.title}</span>
        <BalanceAmount size="md" balance={group.personal_balance} currency={group.currency} />
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {group.pending_count > 0 && (
          <span className="bg-fg text-bg text-[11px] font-semibold rounded-full min-w-[20px] h-5 px-1.5 inline-flex items-center justify-center">
            {group.pending_count}
          </span>
        )}
        <ChevronRight size={18} className="text-faint" />
      </div>
    </button>
  );
}
